import { render } from "./PublicRecordsMisMatchAddress.vue?vue&type=template&id=01b42ec4&ts=true"
import script from "./PublicRecordsMisMatchAddress.vue?vue&type=script&lang=ts"
export * from "./PublicRecordsMisMatchAddress.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\TeamCityBuildAgent\\work\\623dcfb411009e26\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__